// extracted by mini-css-extract-plugin
export default {"body-1":"eBadPs0fgkwpDp1QAhQD","body-2":"Rwl25343wSEXAE7qPrgR","body-3":"ms2fl0S5viwfyJR1ewBN","ant-typography":"n1Wl9L6O1yC5O6JM1VYd","sendBtn":"moF5uG7eBykkdcewpgz7"};